import type {Auth} from 'typings/portaro.be.types';
import type {Observable} from 'rxjs';
import type CurrentAuthService from 'shared/services/current-auth.service';
import type LoginService from 'shared/login/login.service';

export class ErpTopbarService {
    public static serviceName = 'erpTopbarService';

    /*@ngInject*/
    constructor(private loginService: LoginService,
                private currentAuthService: CurrentAuthService) {
    }

    public getCurrentAuth$(): Observable<Auth> {
        return this.currentAuthService.currentAuth$();
    }

    public logout(): Promise<void> {
        return this.loginService.logout();
    }

    public async login(): Promise<void> {
        await this.loginService.login();
    }
}